function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.167 3.166a1 1 0 00-1 1v7.667a1 1 0 001 1h7.667a1 1 0 001-1V9.166a.667.667 0 111.333 0v2.667a2.333 2.333 0 01-2.333 2.333H4.167a2.333 2.333 0 01-2.333-2.333V4.166a2.333 2.333 0 012.333-2.333h2.667a.667.667 0 010 1.333H4.167zM8.501 2.5a.667.667 0 01.666-.667h4.334a.667.667 0 01.666.667v4.333a.667.667 0 11-1.333 0V4.109L9.639 7.304a.667.667 0 11-.943-.942l3.195-3.196H9.167a.667.667 0 01-.666-.666z",
  fill: "#555770"
});

function SvgPopup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPopup;